/** pcp: publishing from the Players list and a player's content side panel. Arabic is a draft for native review. */
const en = {
  "subtitle": "What plays on this player",
  "empty": "Nothing is published to this player yet.",
  "fromGroup": "from group {name}",
  "fromTag": "from tag #{tag}",
  "isPaused": "paused",
  "pause": "Pause",
  "resume": "Resume",
  "remove": "Remove",
  "removeQ": "Remove “{name}” from {player}? The player stops showing it after its next update.",
  "paused": "“{name}” paused on this player",
  "resumed": "“{name}” plays again",
  "removeSharedQ": "Remove “{name}” from {player} only? It comes {from}, which keeps playing it on its other players. You can restore it under Reorder and display settings.",
  "removeManyQ": "Remove {n} item from {player}? Items from a group or tag are removed from this player only. | Remove {n} items from {player}? Items from a group or tag are removed from this player only.",
  "removedN": "{n} item removed from this player | {n} items removed from this player",
  "pausedN": "{n} item paused on this player | {n} items paused on this player",
  "resumedN": "{n} item plays again | {n} items play again",
  "removed": "“{name}” removed from this player",
  "fullList": "Reorder and display settings",
  "publish": "Publish content",
  "publishTo": "Publish content to {name}",
  "publishToN": "Publish to {n} player | Publish to {n} players",
  "nPlayers": "{n} player | {n} players",
  "type_image": "Image",
  "type_video": "Video",
  "type_app": "App",
  "type_campaign": "Campaign",
  "type_playlist": "Playlist",
  "type_pdf": "PDF"
};
const ar: typeof en = {
  "subtitle": "ما يُعرض على هذا المشغّل",
  "empty": "لم يُنشر أي محتوى على هذا المشغّل بعد.",
  "fromGroup": "من المجموعة {name}",
  "fromTag": "من الوسم #{tag}",
  "isPaused": "متوقف مؤقتًا",
  "pause": "إيقاف مؤقت",
  "resume": "استئناف",
  "remove": "إزالة",
  "removeQ": "هل تزيل «{name}» من {player}؟ يتوقف المشغّل عن عرضه بعد تحديثه التالي.",
  "paused": "أُوقف «{name}» مؤقتًا على هذا المشغّل",
  "resumed": "يُعرض «{name}» مجددًا",
  "removeSharedQ": "هل تزيل «{name}» من {player} فقط؟ إنه {from}، ويستمر عرضه على مشغّلاتها الأخرى. يمكنك استعادته من الترتيب وإعدادات العرض.",
  "removeManyQ": "هل تزيل {n} من {player}؟ العناصر الآتية من مجموعة أو وسم تُزال من هذا المشغّل فقط.",
  "removedN": "أُزيل {n} من هذا المشغّل",
  "pausedN": "أُوقف {n} مؤقتًا على هذا المشغّل",
  "resumedN": "يُعرض {n} مجددًا",
  "removed": "أُزيل «{name}» من هذا المشغّل",
  "fullList": "الترتيب وإعدادات العرض",
  "publish": "نشر محتوى",
  "publishTo": "نشر محتوى على {name}",
  "publishToN": "نشر على مشغّل واحد | نشر على {n} مشغّلات",
  "nPlayers": "مشغّل واحد | {n} مشغّلات",
  "type_image": "صورة",
  "type_video": "فيديو",
  "type_app": "تطبيق",
  "type_campaign": "حملة",
  "type_playlist": "قائمة تشغيل",
  "type_pdf": "PDF"
};
export default { en, ar };
